import { Component, Input } from '@angular/core';
import { CsIconModule } from '@components/icon';
import { Router } from '@angular/router';
import {NgClass} from '@angular/common';

@Component({
  selector: 'app-action-with-image-banner',
  imports: [
    CsIconModule,
    NgClass,
  ],
  templateUrl: './action-with-image-banner.component.html',
  standalone: true
})
export class ActionWithImageBannerComponent {
  @Input() imageUrl: string;
  @Input() bannerText: string;
  @Input() bannerSubText: string;
  @Input() navigationLink: string;
  @Input() customStyling: string;

  constructor(private readonly router: Router) {}

  clickToNavigate(): void {
    this.router.navigate([this.navigationLink]);
  }
}
